export default "__VITE_ASSET__BAb5i83c__"